import { BrandRecord } from "records/brand/brand";
import { Item } from "constants/product-collection";
import { cdn } from "constants/media";
import { Map } from "immutable";
import { ImageSize } from "records/item/item";
import { imageFallback } from "helpers/product-helpers";
import fp from "lodash/fp";

export function getProductImages(brand: BrandRecord, product: Map<any, any>, dimension: number): string[] {
    if (!brand || !product) {
        return [];
    }

    if (brand.getPreference("unlimited_images")) {
        const images = product.getIn(Item.FIELDS.IMAGE_URLS)?.split(",") ?? [];

        return images.map((image) => `${image}?max_dimension=${dimension}`);
    }

    return getCdnImages(product, dimension);
}

export function getProductHeroImage(brand: BrandRecord, product: Map<any, any>, dimension: number = 1440): string {
    if (!product) {
        return imageFallback;
    }

    if (brand?.getPreference("unlimited_images")) {
        const image = product.getIn(Item.FIELDS.IMAGE_URL);

        return image ? `${image}?max_dimension=${dimension}` : imageFallback;
    }

    const images = getCdnImages(product, dimension);

    return fp.first(images) ?? imageFallback;
}

function getCdnImages(product: Map<any, any>, dimension: number = 1440): string[] {
    const images = product.getIn(Item.FIELDS.CDN_IMAGES)?.split(",") ?? [];

    return images.map((image) => `//${cdn}/product/${image}${dimensionToSize(dimension)}.jpg`);
}

function dimensionToSize(dimension: number): ImageSize {
    if (dimension < 150) {
        return "T";
    }

    if (dimension <= 400) {
        return "M";
    }

    return "";
}
